import React from "react";
import { Grid, Box, LinearProgress, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import StatBoxSlim from "components/Stats/StatBoxSlim";

const useStyles = makeStyles((theme) => ({
  lblPercent: { marginTop: 32, flexGrow: 1, textAlign: "right", fontSize: 13 },
  tooltip: { position: "absolute", top: "8px", left: "50%", transform: "translateX(-50%)", padding: "5px 10px", borderRadius: "4px", fontSize: "14px", whiteSpace: "nowrap" },
  progress: { marginTop: theme.spacing(1) },
}));

const valueOrDash = value => value === undefined || value === null ? "-" : value;

const PhotoShootSaitama = ({ homeDataPhotoShoot, selectedSeason }) => {
  const classes = useStyles();
  const progress = homeDataPhotoShoot.progressDenchu || {};
  const rate = homeDataPhotoShoot.achievementRate;
  const canProgress = Number.isFinite(rate) && Number(progress.max) > 0;
  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={8} lg={10}>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={6} md={3} lg={2}><StatBoxSlim title="総基数" tip="重複を除くユニークの基数" value={valueOrDash(homeDataPhotoShoot.countAsset)} /></Grid>
          <Grid item xs={12} sm={6} md={3} lg={2}><StatBoxSlim title="レビューOK基数" tip="レビューOKのユニーク基数" value={valueOrDash(homeDataPhotoShoot.countReviewOk)} /></Grid>
          <Grid item xs={12} sm={6} md={3} lg={2}><StatBoxSlim title="街路灯基数" tip="ユニークの街路灯基数" value={valueOrDash(homeDataPhotoShoot.countDenchu)} /></Grid>
          <Grid item xs={12} sm={6} md={3} lg={2}><StatBoxSlim title="撮影者数" tip="レビュー承認済みのユニーク撮影者数" value={valueOrDash(homeDataPhotoShoot.countUniqueUser)} lastItem /></Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} md={4} lg={2}>
        {selectedSeason.length > 0 && (
          <>
            <Typography variant="body2">{`${selectedSeason[0].seasonStart} ~ ${selectedSeason[0].seasonEnd} アセット撮影達成率`}</Typography>
            <div className={classes.lblPercent}>
              <Box width="100%" position="relative">
                <Box className={classes.tooltip}>{canProgress ? `${progress.taken} (${rate.toFixed(2)}%)` : "-"}</Box>
                <Box className={classes.progress}>
                  <LinearProgress variant="determinate" value={canProgress ? Math.min(rate, 100) : 0} />
                </Box>
                <Box display="flex" justifyContent="space-between" mt={1}>
                  <Typography variant="body2" color="textSecondary">0</Typography>
                  <Typography variant="body2" color="textSecondary">{valueOrDash(progress.max)}</Typography>
                </Box>
              </Box>
            </div>
          </>
        )}
      </Grid>
    </Grid>
  );
};

export default PhotoShootSaitama;
